import { MenuItem } from "@mui/material"
import { ImportAccountNumbersFormValues } from "../accountNumbersTypes"
import { CompanyAccountNumbersQuery, fetchDimensionsForCompany } from "../accountNumbersApi"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { useCurrentCompany } from "../../../../hooks/useCurrentCompany"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"

type SelectAccountingDimensionDropdownProps = Readonly<{}>

export function SelectAccountingDimensionDropdown({}: SelectAccountingDimensionDropdownProps) {
    const { companyId } = useCurrentCompany()

    const { data: accountingDimensions = [] } = useApiQuery(fetchDimensionsForCompany, {
        queryName: CompanyAccountNumbersQuery.ACCOUNTING_DIMENSIONS_FOR_COMPANY,
        dependencies: {
            companyId,
        },
        select: (data) => data.accountingDimensions,
    })

    return (
        <LocalizedStrict id="create-or-edit-company-account-numbers-field-accounting-dimension" attrs={{ label: true }}>
            <FormikDropdown<ImportAccountNumbersFormValues> fullWidth name="dimensionId" label="Accounting dimension">
                {accountingDimensions.map((userGroup) => (
                    <MenuItem key={userGroup.id} value={userGroup.id}>
                        {userGroup.name}
                    </MenuItem>
                ))}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
